import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { Currency } from '@/generated/gql/graphql';

export const intakeRequestDetailsStepFormDataSchema = z.object({
  accountingAreaId: z.string().nullish(),
  commodityGroupId: z.string().min(1),
  costCenterId: z.string().nullish(),
  currency: z.enum(Currency),
  deliveryLocationId: z.string().nullish(),
  organizationId: z.string().min(1),
});

export const intakeRequestDetailsStepFormDataDefault: DefaultValues<IntakeRequestDetailsStepFormData> = {
  commodityGroupId: '',
  organizationId: '',
};

export type IntakeRequestDetailsStepFormData = z.infer<typeof intakeRequestDetailsStepFormDataSchema>;
